export default "__VITE_ASSET__Ns3znNCh__"